module.exports = __webpack_public_path__ + "img/honor.777eb0ff.jpeg";